<template>
    <div id="app">
        <div class="main-content" >
            <div class="header-section" >
                <h1>Should I keep it?</h1>
                <!-- no logo yet 
                    <img alt="Vue logo" src="./assets/logo.png"> -->
            </div>

            <div v-for="(item, index) in selections" v-bind:key="index" >
                <div class="section" >
                    <div class="label" >{{item.label}}</div>
                    <selector v-model="item.selectedValue" v-bind:data="item.options" v-on:change="onSelectionChange" ></selector>
                </div>
            </div>

            <div v-if="!showAnswer" >
                <span class="button is-primary" v-on:click="onShowAnswerClick" >Should I keep it?</span>
            </div>
        </div>

        <!-- for debugging calculations -->
        <!-- {{answerValue}} -->

        <div class="answer-content" v-if="showAnswer" >
            <div class="answer" >
                <div v-if="answer">
                    <div class="answer-title" >Yea</div>
                    <p>This item is worth keeping.</p>
                </div>
                <div v-if="!answer">
                    <div class="answer-title" >Na</div>
                    <p>Remove the clutter. Can you sell it or give it away?</p>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import Selector from './parts/Selector.vue'

export default {
    name: 'app',
    data() {
        return {
            showAnswer: false,
            answer: false,
            answerValue: 1,
            selections: [{
                label: "This item is used every:",
                weight: 4,
                selectedValue: 1,
                options: [{
                    value: 1,
                    label: '2 weeks'
                }, {
                    value: 0.8,
                    label: '2 months'
                }, {
                    value: 0.3,
                    label: '1 year'
                },
                {
                    value: 0.0,
                    label: '2 years or less'
                }]
            }, {
                label: "It can be easily replaced:",
                weight: 2,
                selectedValue: 0,
                options: [{
                    value: 0,
                    label: 'Yes'
                }, {
                    value: 1,
                    label: 'No'
                }]
            }, {
                label: "It improves my health:",
                weight: 1,
                selectedValue: 1,
                options: [{
                    value: 1,
                    label: 'Yes'
                }, {
                    value: 0,
                    label: 'No'
                }]
            }, {
                label: "It takes up the space of a:",
                weight: 1,
                selectedValue: 3,
                options: [{
                    value: 3,
                    label: 'Book'
                }, {
                    value: 2,
                    label: 'Bicycle'
                }, {
                    value: 1,
                    label: 'Something larger'
                }]
            }],

        }
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            // do calculations to get a yes or no answer
            // basic maths for now - get fraction and total using weighting

            var calcs = [];
            for (const item of this.selections) {
                // calculate max from options, get fraction of max
                var vals = item.options.map((o) => {return o.value;});
                var max = Math.max(...vals);
                var v = item.selectedValue / max;
                calcs.push({
                    weightedValue: v,
                    weight: item.weight
                });
            }

            var sumWeight = 0;
            calcs.forEach(c => {
                sumWeight = sumWeight + c.weight;
            });
            var sumValues = 0;
            calcs.forEach(c => {
                sumValues = sumValues + (c.weightedValue * c.weight);
            });

            this.answerValue = sumValues / sumWeight;
            this.answer = this.answerValue > 0.5;

        },
        onShowAnswerClick() {
            this.refresh();
            this.showAnswer = true;
        },
        onSelectionChange() {
            // hide answer until the user requests it, this shows a calculation has been made
            this.refresh();
            this.showAnswer = false;
        }

    },
    watch: {

    },
    components: {
        Selector
    }
}
</script>

<style lang="scss">


#app {
    
    .main-content {
        padding: 20px 20px 0 20px;
    }
    .answer-content {
        margin: 0;
        padding: 0;
        .answer {
            padding: 0 20px 0 20px;
        }
    }

    h1 {
        font-size: 1.6em;
    }

    .label {
        font-size: 1em;
        line-height: 1.2em;
    }

    .section {
        margin: 30px 0 30px 0;
        padding: 0;
    }

    .answer {
        .answer-title {
            font-size: 2em;
        }
    }


  
}
</style>
